import { MenuStates } from '@frontend-site/main-header/domain';
import { SystemDetailsResolver } from '@frontend-site/shared/core';
import { PanayaRoute } from '@frontend-site/shared/router-store';
import { LoopbackComponent, OldSitePendingChangesGuard } from '@frontend-site/shared/hybrid';
import { SystemUsersResolver } from '../../../../libs/shared/core/src/lib/system/system-users.resolver';

export const SYSTEM_SETUP_ROUTES: PanayaRoute = Object.freeze<PanayaRoute>({
    path: 'systemSetup',
    canDeactivate: [OldSitePendingChangesGuard],
    data: { navState: 'systemSetup' },
    children: [
        {
            path: ':id',
            resolve: { loadSystemDetails: SystemDetailsResolver, users: SystemUsersResolver },
            data: { navState: 'systemSetup.system', menuState: MenuStates.SETTINGS },
            children: [
                {
                    path: 'main',
                    component: LoopbackComponent,
                    data: { navState: 'systemSetup.system.main' }
                },
                {
                    path: 'uploadEtl',
                    component: LoopbackComponent,
                    data: { navState: 'systemSetup.system.uploadEtl' }
                },
                {
                    path: 'userManag',
                    component: LoopbackComponent,
                    data: { navState: 'systemSetup.system.userManagement' }
                },
                {
                    path: 'rolesManage',
                    component: LoopbackComponent,
                    data: { navState: 'systemSetup.system.rolesManagement' }
                },
                {
                    path: 'ssoConfiguration',
                    component: LoopbackComponent,
                    data: { navState: 'systemSetup.system.sub.ssoConfiguration' }
                },
                {
                    path: 'entityCustomFieldsManagement',
                    component: LoopbackComponent,
                    data: { navState: 'systemSetup.system.sub.entityCustomFieldsManagement' }
                },
                {
                    path: 'defectResolutionWorkflow',
                    component: LoopbackComponent,
                    data: { navState: 'systemSetup.system.sub.defectResolutionWorkflow' }
                },
                {
                    path: 'apiTokens',
                    component: LoopbackComponent,
                    data: { navState: 'systemSetup.system.sub.apiTokens' }
                },
                {
                    path: 'sapConnections',
                    component: LoopbackComponent,
                    data: { navState: 'systemSetup.system.sub.sapConnections' }
                },
                {
                    path: 'oaSystemConfiguration',
                    component: LoopbackComponent,
                    data: { navState: 'systemSetup.system.sub.oaSystemConfiguration' }
                },
                {
                    path: 'exportTemplateManagement',
                    component: LoopbackComponent,
                    data: { navState: 'systemSetup.system.sub.exportTemplateManagement' }
                },
                {
                    path: 'oaCustomAnalysis',
                    component: LoopbackComponent,
                    data: { navState: 'systemSetup.system.sub.oaCustomAnalysis' }
                },
                {
                    path: 'sapSystemLandscape',
                    component: LoopbackComponent,
                    data: { navState: 'systemSetup.system.sub.sapSystemLandscape' }
                },
                {
                    path: 'approvalWorkflowCompanySetup',
                    component: LoopbackComponent,
                    data: { navState: 'systemSetup.system.sub.approvalWorkflowCompanySetup' }
                },
                {
                    path: 'salesforceSetup',
                    component: LoopbackComponent,
                    data: { navState: 'systemSetup.system.sub.salesforceSetup' }
                },
                {
                    path: 'rulesCenter',
                    component: LoopbackComponent,
                    data: { navState: 'systemSetup.system.sub.rulesCenter' }
                },
                {
                    path: 'autoFillDefects',
                    component: LoopbackComponent,
                    data: { navState: 'systemSetup.system.sub.autoFillDefects' }
                },
                {
                    path: 'usageUpload',
                    component: LoopbackComponent,
                    data: { navState: 'systemSetup.system.sub.usageUpload' }
                },
                {
                    path: 'seemoreConfiguration',
                    component: LoopbackComponent,
                    data: { navState: 'systemSetup.system.sub.seemoreConfiguration' }
                },
                {
                    path: 'mfaConfiguration',
                    component: LoopbackComponent,
                    data: { navState: 'systemSetup.system.sub.mfaConfiguration' }
                },
                {
                    path: 'developmentMethodology',
                    component: LoopbackComponent,
                    data: { navState: 'systemSetup.system.sub.developmentMethodology' }
                }
            ]
        }
    ]
});
